import React, { PropsWithChildren } from 'react';

const PageLayoutContent = ({
  children,
  // eslint-disable-next-line react/prop-types
  className = '',
  ...props
}: PropsWithChildren<React.ComponentPropsWithRef<'div'>>) => (
  <div className={`page-layout-content ${className}`} {...props}>
    {children}
  </div>
);

export default PageLayoutContent;
